import type { Locale } from '@app/api'

import deMessagesRaw from '@locales/de.json'
import ruMessagesRaw from '@locales/ru.json'

type MessageTree = {
  [key: string]: string | MessageTree
}

type FlatMessages = Record<string, string>

function flattenMessages(
  messages: MessageTree,
  prefix = '',
  result: FlatMessages = {}
): FlatMessages {
  for (const [key, value] of Object.entries(messages)) {
    const nextKey = prefix.length > 0 ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      result[nextKey] = value
      continue
    }

    flattenMessages(value, nextKey, result)
  }

  return result
}

const deMessages = flattenMessages(deMessagesRaw)
const ruMessages = flattenMessages(ruMessagesRaw)

export type TranslationKey = keyof typeof deMessages

export const localeMessages: Record<Locale, FlatMessages> = {
  de: deMessages,
  ru: ruMessages
}
